import React from 'react'

export const PersonIcon = ({size}: {size: number}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
  >
    <g fill="none">
      <path d="M0 0h24v24H0z" />
      <path
        d="M5 17.667C5 18.833 7.625 20 12 20c4.104 0 7-1.167 7-2.333C19 15.333 16.254 13 12 13c-4.375 0-7 2.333-7 4.667zM12 3.5a3.244 3.244 0 013.235 3.49l-.112 1.48a3.2 3.2 0 01-3.11 2.957 3.048 3.048 0 01-3.116-2.81L8.771 6.99A3.238 3.238 0 0112 3.5z"
        fill="#2A333D"
      />
    </g>
  </svg>
)
